import { sendMessage, unreadTicket, closeTicket, deleteTicket, deleteMessage, markAsSpamTicket } from '../../../redux/actions/tickets';

export const sendMessageFunc = async (dispatch, id, value, files) => {
  // eslint-disable-next-line no-useless-catch
  try {
    await dispatch(
      sendMessage(
        id,
        value,
        files.filter((file) => !file.error).map((file) => ({ name: file.name, size: file.size, url: file.cdn_url })),
      ),
    );
  } catch (error) {
    throw error;
  }
};

export const markAsUnreadFunc = async (dispatch, id, setError, history) => {
  try {
    await dispatch(unreadTicket(id));
    await history.push('/tickets');
  } catch (error) {
    setError(error);
  }
};

export const deleteTicketFunc = async (dispatch, id, setError, history) => {
  try {
    await dispatch(deleteTicket(id));
    await history.push('/tickets');
  } catch (error) {
    setError(error);
  }
};

export const deleteMessageFunc = async (id, ticketID, setError, dispatch, toggleConfirm) => {
  try {
    await dispatch(deleteMessage(id, ticketID));
    setError(false);
    toggleConfirm();
  } catch (error) {
    setError(error);
    toggleConfirm();
  }
};

export const closeTicketFunc = async (dispatch, status, id, setError, history) => {
  try {
    await dispatch(closeTicket(id, status));
    await history.push('/tickets');
  } catch (error) {
    setError(error);
  }
};

export const markAsSpamTicketFunc = async (dispatch, status, id, setError, history) => {
  try {
    await dispatch(markAsSpamTicket(id, status));
    await history.push('/tickets');
  } catch (error) {
    setError(error);
  }
};

export const moveCaret = (e) => {
  const temp_value = e.target.value;
  e.target.value = '';
  e.target.value = temp_value;
};

/**
 * @name prepareConfirmBtnsText
 * @param title {String} - Заголовок события
 */
export const prepareConfirmBtnsText = ({ title }) => {
  switch (title) {
  case 'Delete message':
    return {
      confirmBtnText: 'Delete',
      cancelBtnText: 'Cancel',
    };

  case 'Delete ticket':
    return {
      confirmBtnText: 'Delete',
      cancelBtnText: 'Cancel',
    };

  case 'Close and lock':
    return {
      confirmBtnText: 'Close and lock',
      cancelBtnText: 'Cancel',
      submitStyle: 'primary',
    };

  case 'Close ticket':
    return {
      confirmBtnText: 'Close',
      cancelBtnText: 'Cancel',
      submitStyle: 'primary',
    };

  case 'Mark as spam ticket':
    return {
      confirmBtnText: 'Mark as spam',
      cancelBtnText: 'Cancel',
    };

  default:
    return {
      confirmBtnText: '',
      cancelBtnText: '',
    };
  }
};
